/* eslint-disable react-hooks/rules-of-hooks */
import Card from '@mui/material/Card'
import React, { useCallback, useState, useEffect, useRef } from 'react'
import { useDeviceScopedInit } from 'src/hooks/useDeviceScopedInit'


import { useTranslation } from 'src/utils/i18n'
import { Alert, Badge, Calendar } from 'antd'
import dayjs from 'dayjs'
import PropTypes from 'prop-types'
import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import IconButton from '@mui/material/IconButton'
import { Icon } from '@iconify/react'
import Typography from '@mui/material/Typography'
import ComingSoon from '../pages/misc/coming-soon'
import { useRouter } from 'next/router'
import { StyleProvider } from '@ant-design/cssinjs'

// request
import { getCalendar } from 'src/@api/dashboard'
import IosVerfiyProcess from 'src/@core/components/ios-verfiy-process'
import Image from 'next/image'
import { useDispatch } from 'react-redux'
import { setCurrentTab } from 'src/store/apps/Common'
import ContentLoading from 'src/components/ContentLoading'

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}))

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label='close'
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme => theme.palette.grey[500]
          }}
        ></IconButton>
      ) : null}
    </DialogTitle>
  )
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired
}

const index = () => {

  // 日历数据
  const [useCalendar, setCalendar] = useState([])
  const [open, setOpen] = useState(false)

  const [display, setDisplay] = useState()

  const [travels, setTravels] = useState([])

  const [currentGuid, setCurrentGuid] = useState('')
  const [isLoading, setIsLoading] = useState(true) //正在加载获取数据

  //行程
  const getListData = (value, type) => {
    let listData = []

    const currentYear = value.year()
    const currentMonth = value.month() + 1 >= 10 ? value.month() + 1 : '0' + '' + (value.month() + 1)
    const currentDate = value.date() >= 10 ? value.date() : '0' + '' + value.date()

    let time = String(currentYear) + String(currentMonth) + String(currentDate)

    if (useCalendar != null) {
      if (useCalendar.length > 0) {
        if (type == 'month') {
          for (let i = 0; i < useCalendar.length; i++) {
            // 日数据
            if (time == useCalendar[i].createdDate[0]) {
              useCalendar[i].id = i + useCalendar[i].title
              useCalendar[i].type = 'error'
              useCalendar[i].content = useCalendar[i].title
              listData.push(useCalendar[i])
            }
          }
        } else if (type == 'year') {
          for (let i = 0; i < useCalendar.length; i++) {
            // 月数据
            if (String(currentYear) + String(currentMonth) == String(useCalendar[i].createdDate[0]).substr(0, 6)) {
              useCalendar[i].id = i + useCalendar[i].title
              useCalendar[i].type = 'error'
              useCalendar[i].content = useCalendar[i].title
              listData.push(useCalendar[i])
            }
          }
        }
      }
    }

    return listData || []
  }

  const handleClickOpen = listData => {
    setOpen(true)
    setDisplay(true)
    setTravels(listData)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const monthCellRender = value => {
    const num = getMonthData(value)

    return num ? (
      <div className='notes-month'>
        <div>{num}</div>
      </div>
    ) : null
  }

  const [onClickdate, setOnclickdate] = useState(dayjs().format('YYYY-MMM-DD'))

  const dateFullCellRender = value => {
    const today = dayjs().format('YYYY-MMM-DD')
    const dates = dayjs(value).format('YYYY-MMM-DD')
    const date = dayjs(value).format('D')
    const listData = getListData(value, 'month')

    return (
      <>
        <div
          className='bg-[#F4F4F4] h-[60px] border-b-[1px]'
          onClick={() => setOnclickdate(dates)}
          style={{ color: today === dates && 'red' }}
        >
          <h1
            className='absolute flex top-0 right-0 text-[16px] font-[500] w-[30px] h-[30px] mr-1 rounded-full items-center justify-center mt-1'
            style={{ backgroundColor: dates === onClickdate && 'black', color: dates === onClickdate && 'white' }}
          >
            {date}
          </h1>
          {dateCellRender(value)}
        </div>
      </>
    )
  }

  const [value, setValue] = useState(() => dayjs())

  const [selectedValue, setSelectedValue] = useState(() => dayjs())

  const onSelect = newValue => {
    setValue(newValue)
    setSelectedValue(newValue)
  }

  const onPanelChange = newValue => {
    setValue(newValue)
  }

  const getMonthData = value => {
    const listData = getListData(value, 'year')
    if (listData.length !== 0) {
      return (
        <ul className='events' onClick={() => handleClickOpen(listData)}>
          {listData.map(item => (
            <li key={item.content} className='text-[13px] font-medium'>
              <Badge status={item.type} text={item.content} className='sm:hidden' />
              <i className='flex w-[6px] h-[6px] bg-red-500 rounded-full md:hidden mt-2 '></i>
            </li>
          ))}
        </ul>
      )
    }
  }

  const dateCellRender = value => {
    const listData = getListData(value, 'month')

    return (
      <ul onClick={() => handleClickOpen(listData)} className='w-full h-full'>
        {listData.map(item => (
          <li key={item.content} onClick={() => setTravels(item)} className='text-[13px] font-medium'>
            <div className='absolute flex w-[6px] h-[6px] bg-red-500 rounded-full mb-2 bottom-0 right-0 mr-4'></div>
          </li>
        ))}
      </ul>
    )
  }

  // 分页参数
  const [pagination, setPagination] = useState({
    reqNum: 50, // 单次查询数量
    nowOffset: 0, // 偏移量
    maxNum: false // 全部数据查询完毕
  })

  const getCalendarData = async nowOffset => {
    let response = await getCalendar({
      username:
        JSON.parse(localStorage.getItem('DeviceUser')) != null
          ? JSON.parse(localStorage.getItem('DeviceUser')).username
          : '',
      params: {
        category: 'EVENT',
        offset: nowOffset,
        limit: pagination.reqNum
      }
    })

    if (response.data.contents) {
      setCalendar(old => ([...old, ...response.data.contents]))
    } else {
      setPagination(old => ({ ...old, maxNum: true }))
    }
    setIsLoading(false)
  }

  // 设备切换时重置日历并重新拉数
  useDeviceScopedInit(
    useCallback(() => {
      setCalendar([])
      setPagination({ reqNum: 50, nowOffset: 0, maxNum: false })
      setScroll(0)
      setIsLoading(true)
      getCalendarData(0)
    }, [])
  )

  const domRef = useRef(null)

  // 滚动百分比
  const [scroll, setScroll] = useState(0)

  // 监听进度条滚动
  useEffect(() => {
    const handleScroll = () => {
      if (domRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = domRef.current
        const progress = (scrollTop / (scrollHeight - clientHeight)) * 100
        setScroll(progress.toFixed(0))
      }
    }

    const currentRef = domRef.current
    if (currentRef) {
      currentRef.addEventListener('scroll', handleScroll)
    }

    return () => {
      if (currentRef) {
        currentRef.removeEventListener('scroll', handleScroll)
      }
    }
  }, [])

  useEffect(() => {
    if (scroll >= 100 && !pagination.maxNum) {
      const nowOffset = pagination.nowOffset + pagination.reqNum
      setPagination(old => ({ ...old, nowOffset: nowOffset }))

      getCalendarData(nowOffset)
    }
  }, [scroll])

  const dispatch = useDispatch()
  const { t } = useTranslation('common')

  useEffect(() => {
    const title = t('Calendar')
    dispatch(setCurrentTab(title))

    return () => dispatch(setCurrentTab(''))
  }, [dispatch, t])

  return (
    <>
      {/* <Card className='w-[80%] mx-auto'>
        <StyleProvider className='w-[80%] mx-auto' hashPriority='high'>
          <div className='mx-auto w-11/12 mb-8'>
            <div className='flex justify-between mt-2 items-center'>
              <div className='flex text-[17px] text-red-500 items-center'>
                <Icon icon='material-symbols:chevron-left-rounded' className='w-[30px] h-[30px]' />
                <h1>{dayjs(selectedValue).format('MMM YYYY')}</h1>
              </div>
              <div className='text-[16px] text-red-500 font-[500]'>
                <Icon icon='material-symbols:add-rounded' className='w-[30px] h-[30px]' />
              </div>
            </div>
            <Calendar
              dateCellRender={dateCellRender}
              monthCellRender={monthCellRender}
              onPanelChange={onPanelChange}
              onSelect={onSelect}
              dateFullCellRender={dateFullCellRender}
              fullscreen={true}
              className='w-full overflow-auto'
            ></Calendar>

            <div>
              {travels.map(items => {
                return (
                  <div key={items.id} className='mt-2 p-2'>
                    <li className='flex justify-between'>
                      <div className='flex'>
                        <i className='flex w-[3px] bg-red-500 rounded-2xl'></i>
                        <h1 className='text-[14px] font-[600] ml-3 sm:text-[12px]'>{items.content}</h1>
                      </div>
                      <div>
                        <p className='text-[12px]'>All-day</p>
                      </div>
                    </li>
                  </div>
                )
              })}
              {travels.length === 0 && <p className='text-[#808080] mt-2'>No Events</p>}
            </div>
          </div>

          {display && (
            <div className='flex items-center justify-center mx-auto w-[300px] '>
              <BootstrapDialog onClose={handleClose} aria-labelledby='customized-dialog-title' open={open}>
                <DialogContent dividers>
                  <Alert
                    message={`${selectedValue?.format('dddd')}`}
                    className='w-[500px] sm:w-11/12 h-[50px] border-none text-[30px] font-medium mx-auto text-center sm:text-[20px] text-black text-opacity-70'
                  />
                  <Alert
                    message={`${selectedValue?.format('DD')}`}
                    className='w-[500px] sm:w-11/12 h-[50px] border-none text-[30px] font-medium mx-auto text-center sm:text-[20px] text-[#4d5976] text-opacity-90'
                  />
                  <div className='font-medium  text-[22px] text-[#4d5976] bg-white mt-2 flex items-center'>
                    <Icon icon='material-symbols:edit-calendar-rounded' />
                    Travel plan:
                  </div>
                  <div className='mt-6 w-11/12  mx-auto '>
                    {travels.map(items => {
                      return (
                        <div key={items.id} className='rounded-lg bg-[#F3F4F6] mt-2'>
                          <li className='text-[18px] font-bold '>
                            <Badge status={items.type} text={items.content} className='ml-2' />
                          </li>
                        </div>
                      )
                    })}
                  </div>
                </DialogContent>
                <DialogActions>
                  <Button autoFocus onClick={handleClose}>
                    I see
                  </Button>
                </DialogActions>
              </BootstrapDialog>
            </div>
          )}
        </StyleProvider>
      </Card> */}

      <div ref={domRef} className='bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] Bxl:h-[calc(var(--vh2)*100-90px)] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)] px-[8px] pt-[16px] pb-[8px] flex flex-col overflow-auto relative'>
        {isLoading ? (
          <div className='absolute inset-0 z-[20] bg-[#FFF] rounded-[10px]'>
            <ContentLoading />
          </div>
        ) : null}
        {useCalendar &&
          useCalendar.map((item, index) => (
            <div
              key={index}
              className={`${item.guid === currentGuid ? 'bg-[#E7F7FF]' : 'bg-[#F4F5F7]'
                } 'w-full rounded-[8px] mb-[8px] cursor-pointer`}
            >
              <div
                className='px-[15px] py-[11px]'
                onClick={() => {
                  if (item.guid === currentGuid) {
                    setCurrentGuid('')
                  } else {
                    setCurrentGuid(item.guid || item.eventId)
                  }
                }}
              >
                <div className='flex justify-between items-center'>
                  <h2 className='text-[18px] font-[600] text-[#000]'>{item.title}</h2>
                  <Image
                    src={
                      item.guid === currentGuid ? '/images/calendars/pull-up.svg' : '/images/calendars/drop-down.svg'
                    }
                    width={12}
                    height={12}
                    alt='drop'
                  />
                </div>
                <div className='flex justify-between items-center mt-[11px]'>
                  <span className='text-[13px] font-[600] text-[#000]'>{t('Started at')}:</span>
                  <span className='ml-[5px] text-[13px] text-[#000]'>
                    {item.startDate[1]}-{('0' + item.startDate[2]).slice(-2)}-{('0' + item.startDate[3]).slice(-2)}
                    &ensp;
                    {('0' + item.startDate[4]).slice(-2)}:{('0' + item.startDate[5]).slice(-2)}
                  </span>
                </div>
              </div>
              {item.guid === currentGuid && (
                <div
                  className='cursor-default px-[15px] pb-[11px]'
                  onClick={e => {
                    e.stopPropagation()
                  }}
                >
                  <div className='flex justify-between items-center'>
                    <span className='text-[13px] font-[600] text-[#000]'>{t('Completed at')}:</span>
                    <span className='ml-[5px] text-[13px] text-[#000]'>
                      {item.endDate[1]}-{('0' + item.endDate[2]).slice(-2)}-{('0' + item.endDate[3]).slice(-2)}
                      &ensp;
                      {('0' + item.endDate[4]).slice(-2)}:{('0' + item.endDate[5]).slice(-2)}
                    </span>
                  </div>
                  <div className='flex justify-between items-center mt-[11px]'>
                    <span className='text-[13px] font-[600] text-[#000]'>{t('Location')}:</span>
                    <span className='ml-[5px] text-[13px] text-[#000]'>{item.tz}</span>
                  </div>
                  <div className='flex justify-between items-center mt-[11px]'>
                    <span className='text-[13px] font-[600] text-[#000]'>{t('Description')}:</span>
                    <span className='ml-[5px] text-[13px] text-[#000] overflow-hidden'>{item.description}</span>
                  </div>
                </div>
              )}
            </div>
          ))}
        {(useCalendar.length > 0 || isLoading) ||
          <div className='text-center px-2 absolute inset-0 flex justify-center items-center pointer-events-none'>
            {t('It appears theres no data to show here yet')}<br />
            {t('If data exists it may take up to 1 hour to download and appear')}<br />
            {t('We suggest checking back in a little while')}
          </div>}
      </div>
    </>
  )
}

export default index


